import { URL_CONFIG } from "./urlConfig";

const BASE_API_URL = URL_CONFIG.API_URL;

export const API_URLS = {
  COMPARE_BBPS_ID: `${BASE_API_URL}partner/v1/apb/CompareBBPSID`,
  ADD_PRIMARY_BBPS_ID: `${BASE_API_URL}partner/v1/apb/AddPrimaryBBPSID`,
};
